<script setup>

    import { computed, ref, watch } from 'vue'
    import { factory } from '@/Validators'


    const props = defineProps({
        modelValue: {
            type: [ Object, String ],
            default: {}
        },
        options: {
            type: Array,
            required: true
        },
        useId: {
            type: Boolean,
            default: false
        },
        showNullOption: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '—'
        },
        input_class: {
            type: String,
            default: 'bg-white text-stone-700'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: 'h-[34px]'
        },
        validate: {
            type: Array,
            default: () => []
        }
    })

    const emit = defineEmits(['update:modelValue'])

    const modelProxy = computed({
      get: () => JSON.stringify(props.modelValue),
      set: (value) => emit('update:modelValue', JSON.parse(value)),
    })

    const isValid = ref(true)

    watch(() => props.modelValue, (value) => {
        if (props.validate.includes('nullable') && !value) {
            isValid.value = true
            return;
        }

        for (let i in props.validate) {
            const validator = factory(props.validate[i])

            if (validator.isValid(value) == false) {
                isValid.value = false
                return;
            }

            isValid.value = true
        }
    }, { immediate: true })

</script>

<template>

        <select
            v-model="modelProxy"
            :disabled="props.disabled"
            :class="[
                'relative w-full pl-2.5 pr-10 md:px-2.5 py-7 md:py-1.5 rounded-md text-base tracking-wider sm:text-sm shadow-sm focus:outline-none',
                props.input_class,
                props.disabled ? 'cursor-default' : 'cursor-pointer',
                props.height,
                !isValid ? 'border-lifeworx-red-500 focus:ring-1 focus:border-lifeworx-red-500 focus:ring-lifeworx-red-500 bg-lifeworx-red-500 bg-opacity-10' : 'border border-stone-400 focus:border-lifeworx-blue-600 focus:ring-lifeworx-blue-600 focus:ring-1'
            ]"
        >
            <option
                v-if="props.showNullOption"
                :value="JSON.stringify({ id: null, name: '' })"
            >
                {{ props.placeholder }}
            </option>
            <option
                v-for="(option, index) in props.options"
                :key="option.id"
                :value="JSON.stringify(option)"
            >
                {{ props.useId ? option.id : option.name }}
            </option>
        </select>

</template>
